<form name="form" (ngSubmit)="f.form.valid && secondarysubmit()" #f="ngForm" novalidate>
    <div id="top" class="wrapper mt-0 {{formClass}}">
     
      <div class="modal-body">
        <h2 class="sub-header-text">Select Your Areas of Focus {{ textOptional }}</h2>
        <div class="row" *ngIf="!educationSelected">
            <div class="col-lg-12">
              <h5 class="sub-name ">{{ _parent.model.bucket_text }}</h5>
            </div>
            <div class="col-lg-12">
              <ul class="list">
                <li *ngFor='let blist of secondaryBucketList'>
                 <div class="form-group">
                  <label class="check-box">
                    <input value="{{ blist.secBucketId }}" type="checkbox" (change)="checkSecondaryBucket($event,blist.secBucketId,blist.secBucketTitle)" [checked]="getCheckboxValue(blist.secBucketId)">
                    <span class="checked1 secondary_bucket"></span>
                    <p class="subject-category">{{ blist.secBucketTitle }}</p>
                 </label>
                 </div>
                </li>
              </ul>
            </div>
          
          </div>

          
        <div class="row" *ngIf="educationSelected">
          <div class="col-lg-12">
            <h5 class="sub-name ">Subject</h5>
          </div>
          <div class="col-lg-12">
            <ul class="list">
              <li *ngFor='let blist of secondaryBucketList | slice:0:11'>
               <div class="form-group">
                <label class="check-box">
                  <input value="{{ blist.secBucketId }}" type="checkbox" (change)="checkSecondaryBucket($event,blist.secBucketId,blist.secBucketTitle)" [checked]="getCheckboxValue(blist.secBucketId)">
                  <span class="checked1 secondary_bucket"></span>
                  <p class="subject-category">{{ blist.secBucketTitle }}</p>
               </label>
               </div>
              </li>
            </ul>
          </div>

          <div class="col-lg-12">
            <h5 class="sub-name ">Level</h5>
          </div>
          <div class="col-lg-12">
            <ul class="list">
              <li *ngFor='let blist of secondaryBucketList | slice:11:15'>
               <div class="form-group">
                <label class="check-box">
                  <input value="{{ blist.secBucketId }}" type="checkbox" (change)="checkSecondaryBucket($event,blist.secBucketId,blist.secBucketTitle)" [checked]="getCheckboxValue(blist.secBucketId)">
                  <span class="checked1 secondary_bucket"></span>
                  <p class="subject-category">{{ blist.secBucketTitle }}</p>
               </label>
               </div>
              </li>
            </ul>
          </div>

          <div class="col-lg-12">
            <h5 class="sub-name ">Other</h5>
          </div>
          <div class="col-lg-12">
            <ul class="list">
              <li *ngFor='let blist of secondaryBucketList | slice:15'>
               <div class="form-group">
                <label class="check-box">
                  <input value="{{ blist.secBucketId }}" type="checkbox" (change)="checkSecondaryBucket($event,blist.secBucketId,blist.secBucketTitle)" [checked]="getCheckboxValue(blist.secBucketId)">
                  <span class="checked1 secondary_bucket"></span>
                  <p class="subject-category">{{ blist.secBucketTitle }}</p>
               </label>
               </div>
              </li>
            </ul>
          </div>
        
        </div>
          <div class="error-display" *ngIf="errdisplay ">
            <ul class="p-0">
              <li *ngFor='let msg of errormsg' class="errorclass">{{ msg }}</li>
            </ul>
          </div>
      </div> 

      <div class=" m-footer modal-footer flex-column">
       <div class="d-flex justify-content-between w-100">
        <a href="javascript:void(0)" (click)="prevAction()" role="button" class="btn  btn-prev btn-sm">
          <i class="fas fa-arrow-left pr-2"></i>Prev
        </a>
        <div class="slider-scroll">
          <ul>
            <li class="d-inline"><i class="far fa-circle"></i></li>
            <li class="d-inline"><i class="far fa-circle"></i></li>
            <li class="d-inline"><i class="fas fa-circle"></i></li>
            <li class="d-inline"><i class="far fa-circle"></i></li>
            <li class="d-inline"><i class="far fa-circle"></i></li>
          </ul>
        </div>
        <a href="javascript:void(0)" (click)="clickSubmit(f.form.valid)" class="btn btn-next btn-sm">
          NEXT<i class="fas fa-arrow-right pl-2"></i>
        </a>
      </div>
       <div id="footer" class="text-center mt-3">
        <p>© {{ _parent.year }} CollegeRecon. All rights reserved.</p>
     </div>
      </div>
    </div>
</form>   


// WEBPACK FOOTER //
// ./src/app/components/pworkflow/secondary/secondary.component.html